import React, { useRef, useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import FormButtonStyle4 from "../../UIElements/FormButton";
import { toast } from "react-toastify";
import callApi from "../../../../utility/apiCaller";
import { setUserClickData } from "../../../../utility/setUserClickData";
import { useDispatch } from "react-redux";
import { login } from "../../../../store/app/appReducer";
import { useSelector } from "react-redux";

export default function OTPVerification({
  mobile,
  setCurrentStep,
  currentStep,
}) {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const inputRefs = useRef([]);
  const [isLoading, setIsLoading] = useState(false);
  const { lenderName, lenderId } = useSelector((state) => state.app.lead);
  const isConsentChecked = true;
  const dispatch = useDispatch();
  const [affId, setaffId] = useState("");

  const handleChange = (value, index) => {
    if (/^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 3) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  //console.log(lenderId, "lenderID");

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleResendOtp = async () => {
    try {
      setIsLoading(true);
      const response = await callApi(
        "v1/sms/send-otp",
        "post",
        {
          contact_phone: mobile,
          kyc_consent: isConsentChecked,
          kyc_consent_datetime: new Date().toISOString(),
        },
        "messaging"
      );
      if (response.status === "Success") {
        setUserClickData({
          event_name: `resend-otp-for-dmi`,
          user_id: mobile || "unknown",
          affiliate_id: affId || "No Aff_id found",
        });
        toast.success("OTP Resent Successfully");
      } else {
        toast.error("Failed to resend OTP.");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while resending OTP.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleOtpSubmit = async () => {
    if (otp.length !== 4) {
      toast.error("Please enter a valid 4-digit OTP.");
      return;
    }

    const otpJoined = otp.join("");

    try {
      const otpResponse = await callApi(
        "v1/sms/validate-otp",
        "post",
        {
          contact_phone: mobile,
          otp: otpJoined,
          lender_id: lenderId,
        },
        "messaging"
      );

      if (otpResponse.status === "Success") {
        setUserClickData({
          event_name: `otp-submit-for-dmi`,
          user_id: mobile || "unknown",
          affiliate_id: affId || "No Aff_id found",
        });
        toast.success("OTP Verified Successfully");

        dispatch(
          login({
            ...otpResponse.data.customer,
            token: otpResponse.data.token,
          })
        );
        localStorage.setItem("mobile", mobile);

        setCurrentStep(3);
      } else {
        toast.error("Invalid OTP. Please try again.");
      }
    } catch (otpError) {
      console.error("Error occurred while verifying OTP:", otpError);
      toast.error("An error occurred while verifying OTP. Please try again.");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-[calc(100dvh-50%)] bg-white  px-4">
      {/* Title */}
      <div className="flex items-center gap-3 mb-2">
        <div className="w-10 border-t border-gray-300"></div>
        <h1 className="text-[clamp(1rem,5vw,20px)] font-atkinson font-bold">
          Mobile OTP verification
        </h1>
        <div className="w-10 border-t border-gray-300"></div>
      </div>

      {/* Subtext */}
      <p className="text-[#B3B3B3] text-center text-[12px] leading-[14px] font-atkinson max-w-md ">
        A One Time Password (OTP) has been sent to your mobile <br /> number{" "}
        <span className="font-bold text-[#000000]">{mobile}</span>{" "}
        <button 
        onClick={() => setCurrentStep(currentStep - 1)}
        className="text-blue-500">Edit</button> Please enter the OTP
        below
      </p>

      {/* OTP Inputs */}
      <div className="flex gap-3 mb-6 mt-3">
        {otp.map((digit, index) => (
          <input
            key={index}
            ref={(el) => (inputRefs.current[index] = el)}
            type="text"
            maxLength={1}
            value={digit}
            placeholder="-"
            onChange={(e) => handleChange(e.target.value, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            className="w-[71px] xs:w-[65px] h-[50px] text-center text-[20px] border-[1px] font-atkinson text-[#1B1B1B] border-[#B3B3B3] font-bold rounded-md focus:border-green-800  outline-none  placeholder-gray-400 leading-[3.5rem]"
          />
        ))}
      </div>

      {/* Verify Button */}
      <FormButtonStyle4 text="Continue" onClick={handleOtpSubmit} />

      {/* Regenerate OTP */}
      <p className="text-gray-500 text-[12px] font-atkinson mt-4">
        Don't receive the OTP? Click here to{" "}
        <button onClick={handleResendOtp} className="text-blue-500">
          Regenerate OTP
        </button>
      </p>
    </div>
  );
}
